export default {"src":"/_next/static/media/dragonfruit.30b98b48.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};